import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const NoResults = () => {
  const { t } = useTranslation();

  return (
    <div className="VolunteerWorkNoResults">
      <div className="VolunteerWorkNoResults__title">{t('no_results_title')}</div>
      <div className="VolunteerWorkNoResults__description">{t('no_results_description')}</div>
    </div>
  );
};

export default NoResults;
